import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { FinalCTA } from './components/FinalCTA';
import { HomePage } from './pages/HomePage';
import { HumanCapabilityPage } from './pages/HumanCapabilityPage';
import { SemanticKnowledgePage } from './pages/SemanticKnowledgePage';
import { Footer } from './components/Footer';
import { CJIPage } from './components/CJIPage';
import { NCJIPage } from './components/NCJIPage';
import { SolutionsPage } from './components/SolutionsPage';
import { AboutPage } from './components/AboutPage';
import { ResearchPage } from './components/ResearchPage';
import { PartnershipsPage } from './components/PartnershipsPage';
import { ContactPage } from './components/ContactPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
import { GovernmentPage } from './components/GovernmentPage';
import { EducationPage } from './components/EducationPage';
import { EmployersPage } from './components/EmployersPage';
import { CivilSocietyPage } from './components/CivilSocietyPage';
import { LeadershipPage } from './components/LeadershipPage';
import { ReasoningQualityPage } from './components/ReasoningQualityPage';
import { ConsequentialThinkingPage } from './components/ConsequentialThinkingPage';
import { ManipulationResistancePage } from './components/ManipulationResistancePage';
import { EmotionalRegulationPage } from './components/EmotionalRegulationPage';
import { SocialCooperationPage } from './components/SocialCooperationPage';
import { SelfDirectionPage } from './components/SelfDirectionPage';
import { LeadershipResponsibilityPage } from './components/LeadershipResponsibilityPage';
import { IndividualLevelPage } from './components/IndividualLevelPage';
import { OrganizationalLevelPage } from './components/OrganizationalLevelPage';
import { MunicipalScalePage } from './components/MunicipalScalePage';
import { NationalScalePage } from './components/NationalScalePage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'home';
      setCurrentPage(hash);
      window.scrollTo(0, 0);
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const renderPage = () => {
    switch (currentPage) {
      case 'cji':
        return <>
            <CJIPage data-id="element-0" data-mp="3bk702e94zu5v" />
            <FinalCTA data-id="element-1" data-mp="3qb7k7gj8xchu" />
          </>;
      case 'ncji':
        return <>
            <NCJIPage data-id="element-2" data-mp="3lkhe212zx5m3" />
            <FinalCTA data-id="element-3" data-mp="3ljxygr0titb8" />
          </>;
      case 'solutions':
        return <>
            <SolutionsPage data-id="element-4" data-mp="2xu3k250uowov" />
            <FinalCTA data-id="element-5" data-mp="2xtbyzo4vqhcu" />
          </>;
      case 'about':
        return <>
            <AboutPage data-id="element-6" data-mp="2svah36j6wo2y" />
            <FinalCTA data-id="element-7" data-mp="2stplddl52z3i" />
          </>;
      case 'research':
        return <>
            <ResearchPage data-id="element-8" data-mp="18bolyqu3ijz2" />
            <FinalCTA data-id="element-9" data-mp="1d47yrlkylb2t" />
          </>;
      case 'partnerships':
        return <>
            <PartnershipsPage data-id="element-10" data-mp="yg3n31kbpztj" />
            <FinalCTA data-id="element-11" data-mp="ygwjb8lnp6xf" />
          </>;
      case 'contact':
        return <>
            <ContactPage data-id="element-12" data-mp="13fgabnf3x8wn" />
            <FinalCTA data-id="element-13" data-mp="13clpvvw3fo38" />
          </>;
      case 'privacy':
        return <PrivacyPolicyPage data-id="element-14" data-mp="1r5k8vgdfuigs" />;
      case 'terms':
        return <TermsOfServicePage data-id="element-15" data-mp="1w33ookpsb3au" />;
      case 'government':
        return <>
            <GovernmentPage data-id="element-16" data-mp="1i3ktesi2nmfy" />
            <FinalCTA data-id="element-17" data-mp="1i4cdb62b3vqe" />
          </>;
      case 'education':
        return <>
            <EducationPage data-id="element-18" data-mp="1m44qjw2naq23" />
            <FinalCTA data-id="element-19" data-mp="1m3ctshxbama8" />
          </>;
      case 'employers':
        return <>
            <EmployersPage data-id="element-20" data-mp="6n48wkrnufm8" />
            <FinalCTA data-id="element-21" data-mp="aq0wyqzyz3xk" />
          </>;
      case 'civil-society':
        return <>
            <CivilSocietyPage data-id="element-22" data-mp="qwvos6dw892o" />
            <FinalCTA data-id="element-23" data-mp="qy73h18vn18k" />
          </>;
      case 'leadership':
        return <>
            <LeadershipPage data-id="element-24" data-mp="m5dxyb5l3ovf" />
            <FinalCTA data-id="element-25" data-mp="m5458ft5n3m1" />
          </>;
      case 'reasoning-quality':
        return <>
            <ReasoningQualityPage data-id="element-26" data-mp="h59dyb5gwc0g" />
            <FinalCTA data-id="element-27" data-mp="c8rdvol311ug" />
          </>;
      case 'consequential-thinking':
        return <>
            <ConsequentialThinkingPage data-id="element-28" data-mp="19uyj90p7my7v" />
            <FinalCTA data-id="element-29" data-mp="19tx6mrsjq3o1" />
          </>;
      case 'manipulation-resistance':
        return <>
            <ManipulationResistancePage data-id="element-30" data-mp="zxtuqu7w6qnw" />
            <FinalCTA data-id="element-31" data-mp="zwskut2m4a7r" />
          </>;
      case 'emotional-regulation':
        return <>
            <EmotionalRegulationPage data-id="element-32" data-mp="vvgtai06hewx" />
            <FinalCTA data-id="element-33" data-mp="vyl5a1jvxey5" />
          </>;
      case 'social-cooperation':
        return <>
            <SocialCooperationPage data-id="element-34" data-mp="3gmpkwbnbwtmn" />
            <FinalCTA data-id="element-35" data-mp="3glekmlt3e40a" />
          </>;
      case 'self-direction':
        return <>
            <SelfDirectionPage data-id="element-36" data-mp="1w5q3kdbpy19f" />
            <FinalCTA data-id="element-37" data-mp="1w2ltx0fhidbd" />
          </>;
      case 'leadership-responsibility':
        return <>
            <LeadershipResponsibilityPage data-id="element-38" data-mp="2553elafhqxw9" />
            <FinalCTA data-id="element-39" data-mp="254bm48h6xga7" />
          </>;
      case 'individual-level':
        return <>
            <IndividualLevelPage data-id="element-40" data-mp="29xefafi22npv" />
            <FinalCTA data-id="element-41" data-mp="2euwsii33vp3o" />
          </>;
      case 'organizational-level':
        return <>
            <OrganizationalLevelPage data-id="element-42" data-mp="2jtrajht919mq" />
            <FinalCTA data-id="element-43" data-mp="2jsohp4cd8x46" />
          </>;
      case 'municipal-scale':
        return <>
            <MunicipalScalePage data-id="element-44" data-mp="2nw4f42w9f1hx" />
            <FinalCTA data-id="element-45" data-mp="2ntrvllausj2r" />
          </>;
      case 'national-scale':
        return <>
            <NationalScalePage data-id="element-46" data-mp="thlde2jjl20y" />
            <FinalCTA data-id="element-47" data-mp="timzd223j8xg" />
          </>;
      case 'human-capability':
        return <HumanCapabilityPage data-id="element-48" data-mp="yg4xdxeks3qo" />;
      case 'semantic-knowledge':
        return <SemanticKnowledgePage data-id="element-49" data-mp="yihp32a4xsgx" />;
      case 'home':
      default:
        return <HomePage data-id="element-50" data-mp="21ru7rhd72lhg" />;
    }
  };
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-51" data-mp="1wshcq9c6683s">
      <Navigation data-id="element-52" data-mp="2ass2f91qtgnd" />
      <main data-id="element-53" data-mp="2atbjknjkk10c">{renderPage()}</main>
      <Footer data-id="element-54" data-mp="2atjzkoaznmfr" />
    </div>;
}